<template>
  <div class="w1200 newsBox">
    <div class="bannerBox">
      <Banner  :big="true"/>
    </div>
    <div>
      <Firstcolumn v-if="newsIinitData.specialType" :columnlist="columnlist" :alldata="newsIinitData" />
    </div>
  </div>
</template>
<script>
import Banner from '@/components/banner_smoll'
import Firstcolumn from '@/views/firstlist/firstcolumn_specialTopic'

export default {
  components: { Banner, Firstcolumn },
  head() {
    // var listObj = this.$store.state.hotList_home
    var metaStr = ''
    // listObj.forEach(a => {
    //   metaStr += a.CONTENT_TITLE + ' | '
    // })
    return {
      title: '专题-彭祖世家网Pengzushijia.com',
      mateDesc: metaStr
    }
  },
  computed: {
    columnlist() {
      var arrs = this.$store.state.specialData.specialType
      if (arrs) {
        if (arrs[0].value !== '') {
          arrs.unshift({ 'value': '', 'name': '全部' })
        }
      }
      return arrs
    },

    newsIinitData() {
      return this.$store.state.specialData
    }
  },
  asyncData({ store, route }) {
    return store.dispatch('getspecialInitData')
  },
  mounted() {
    this.fn()
  },
  methods: {
    fn: function() {
      window.scrollTo(0, 0)
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
  .newsBox{
    background-color: #fafafa;
    overflow: hidden;
    position: relative;
    .bannerBox{
      width: 1200px;
      height: 340px;
      margin-top: 20px;
    }
  }
</style>

<!--手机端样式-->
<style rel="stylesheet/scss" lang="scss" scoped>
  @media screen and (max-width: 750px) {
    .newsBox{
      width: 100%;
      margin-top: 0;
      .bannerBox{
        width: 100%;
        height: auto;
      }
    }
  }
</style>
